module.exports = __webpack_public_path__ + "img/26_118.b61b0c82.png";